/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHealthAndSafetyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-health-and-safety"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.5 13L10.5 14.82Q10.5 15.1 10.7 15.3Q10.9 15.5 11.18 15.5L12.85 15.5Q13.13 15.5 13.31 15.3Q13.5 15.1 13.5 14.82L13.5 13L15.35 13Q15.63 13 15.81 12.8Q16 12.6 16 12.32L16 10.65Q16 10.38 15.81 10.19Q15.63 10 15.35 10L13.5 10L13.5 8.15Q13.5 7.88 13.31 7.69Q13.13 7.5 12.85 7.5L11.18 7.5Q10.9 7.5 10.7 7.69Q10.5 7.88 10.5 8.15L10.5 10L8.68 10Q8.4 10 8.2 10.19Q8 10.38 8 10.65L8 12.32Q8 12.6 8.2 12.8Q8.4 13 8.68 13ZM12 22.73Q12 22.73 11.9 22.73Q11.8 22.73 11.6 22.69Q11.4 22.65 11.2 22.6Q7.55 21.45 5.4 18.14Q3.25 14.82 3.25 11.1L3.25 6.28Q3.25 5.45 3.73 4.78Q4.2 4.1 4.97 3.8L11.07 1.5Q11.53 1.32 12 1.32Q12.47 1.32 12.93 1.5L19.02 3.8Q19.8 4.1 20.27 4.78Q20.75 5.45 20.75 6.28L20.75 11.1Q20.75 14.82 18.6 18.14Q16.45 21.45 12.8 22.6Q12.6 22.65 12.4 22.69Q12.2 22.73 12 22.73Z" fill={color} />
    </svg>
  );
}
